export const environment = {
  production: true,
  apiUrl: 'https://api-dev.championsinsurance.co.zw/insurance-core',
  rootUsername: '000000000Z00',
  rootPassword: 'password@2',
};
